import { GenericValueLongText } from 'app/rm/erp/common/model/genericvaluelongtext';

export class BankDetails {
    accountIban?: string;
    accountBic?: string;
    changeBankDetails?: boolean;
    changeAccountNewIban?: string;
    changeAccountNewBic?: string;
}

export class Account extends GenericValueLongText {
    validFromDate?: Date;
    validToDate?: Date;
    accountIban?: string;
    accountBic?: string;
}
